import type { ReactNode } from "react";
import { cn } from "cn";

export interface CollectionRefreshRegionProps {
    isRefreshing: boolean;
    className?: string;
    children: ReactNode;
}

export function CollectionRefreshRegion({ isRefreshing, className, children }: CollectionRefreshRegionProps) {
    return (
        <div inert={isRefreshing} className={cn("transition-opacity duration-200", isRefreshing && "opacity-60", className)}>
            {children}
        </div>
    );
}
